export const RETURNS_CHANGE_VIEW = 'RETURNS_CHANGE_VIEW';
export const changeView = (viewId, goToPageOne = true) => ({
  type: RETURNS_CHANGE_VIEW,
  viewId,
  goToPageOne,
});

export const RETURNS_VIEWS_CHANGED = 'RETURNS_VIEWS_CHANGED';
export const returnsViewsChanged = () => ({
  type: RETURNS_VIEWS_CHANGED,
});

export const RETURNS_SEARCH = 'RETURNS_SEARCH';
export const returnsSearch = (searchData) => ({
  type: RETURNS_SEARCH,
  searchData,
});

export const RETURNS_SEARCH_SUCCESS = 'RETURNS_SEARCH_SUCCESS';
export const returnsSearchSuccess = ({ results, statusList }) => ({
  type: RETURNS_SEARCH_SUCCESS,
  results,
  statusList,
});

export const CLEAR_SEARCH_INPUT = 'CLEAR_SEARCH_INPUT';
export const clearSearchInput = () => ({
  type: CLEAR_SEARCH_INPUT,
});

export const RETURNS_SEARCH_TERM_COUNT = 'RETURNS_SEARCH_TERM_COUNT';
export const returnsSearchTermCount = () => ({
  type: RETURNS_SEARCH_TERM_COUNT,
});

export const RETURNS_SEARCH_COUNT_SUCCESS = 'RETURNS_SEARCH_COUNT_SUCCESS';
export const returnsSearchTermCountSuccess = ({ statusList }) => ({
  type: RETURNS_SEARCH_COUNT_SUCCESS,
  statusList,
});
